export default __webpack_public_path__ + "static/media/lackier_start.7aa7d6df.png";